import {ListingsRepository} from "../../core/api/ApiRepository";
import {SimilarToClickListingsServiceQuery} from "./SimilarToClickListingsServiceQuery";
import {EventBus} from "../../../../common/ts/events/EventBus";
import {SerpListingsUpdatedEvent} from "../../../../common/ts/events/Events";

export default class SimilarToClickListingsService {
    private readonly eventBus: EventBus;
    private readonly listingsRepository: ListingsRepository;

    constructor(
        eventBus: EventBus,
        listingsRepository: ListingsRepository
    ) {
        this.eventBus = eventBus;
        this.listingsRepository = listingsRepository;
    }

    public execute(query: SimilarToClickListingsServiceQuery): void {
        const listingElement = query.listing;
        if (listingElement) {
            this.listingsRepository.getSimilarToClickListings(query).then((response) => {
                const tempDiv = document.createElement('div');
                const similarListingsContent = response.trim();
                if (similarListingsContent !== '') {
                    tempDiv.innerHTML = similarListingsContent;
                    listingElement.insertAdjacentHTML('afterend', tempDiv.innerHTML);
                    this.eventBus.emit(new SerpListingsUpdatedEvent());
                }
            });
        }
    }
}
